import React, { ReactNode, useEffect } from 'react';
import { DisplayText } from '@superops/ui-design-system';
import { FormattedMessage } from 'react-intl';
import { Pagination, useSuperListHook } from '@nile/components';
import { components } from 'react-select';
import pages from '@nile/reports/src/modules/DataReports/components/pages';

const ListItems = ({
  components,
  allItems = [],
  setSelectedItemWrapper,
  selectAll,
  setSelectAll,
  onItemUnselected,
  activeView,
  context,
  selectedItem,
  isRefetching,
  listInfo,
  globalStateConditions,
  setGlobalStateConditions,
  itemKeyName,
  noDataMessage,
  module,
  tableName,
  selectedRecords = [],
  classicViewHook
}): ReactNode => {
  // Use useSuperListHook instead of context.setRecords

  const { selectedRecords: selectedRecordsHook, updateRecords } =
    classicViewHook || {};

  selectedRecords = module === 'patch' ? selectedRecords : selectedRecordsHook;

  const pagination = listInfo
    ? Math.ceil(listInfo?.totalCount / listInfo?.pageSize) > 1
    : false;

  const navigatePages = ({ pageNumber }) => {
    setSelectedItemWrapper(null);
    setGlobalStateConditions({
      ...globalStateConditions,
      pageNumber
    });
  };

  const PaginationWrapper = !pagination ? (
    <></>
  ) : (
    <div className="pl8">
      <Pagination
        onPageChange={(pageNumber) => navigatePages({ pageNumber })}
        recordCount={listInfo?.totalCount}
        pages={
          listInfo ? Math.ceil(listInfo.totalCount / listInfo.pageSize) : 0
        }
        page={listInfo?.page || 0}
      />
    </div>
  );

  useEffect(() => {
    const currentSelectedCount =
      module === 'invoice'
        ? (context?.records?.selectedRecords || []).length
        : (selectedRecords || []).length;

    if (currentSelectedCount < 20) {
      onItemUnselected?.();
    }
  }, [
    selectedRecords,
    context?.records?.selectedRecords,
    module,
    onItemUnselected
  ]);

  const handleCheckboxChange = (record) => {
    if (module === 'ticket') {
      if (!selectedRecords || !Array.isArray(selectedRecords)) {
        console.warn('selectedRecords is not an array', selectedRecords);
        return;
      }

      const recordId = record[itemKeyName];
      const isAlreadySelected = selectedRecords.some(
        (item) => item[itemKeyName] === recordId
      );

      const newSelected = isAlreadySelected
        ? selectedRecords.filter((item) => item[itemKeyName] !== recordId)
        : [...selectedRecords, record];

      // Update the context with the new selection
      updateRecords?.(newSelected);
    } else if (module === 'patch') {
      const currentSelection = context?.records || [];

      const recordId = record[itemKeyName];
      const isAlreadySelected = currentSelection.some(
        (item) => item[itemKeyName] === recordId
      );

      const newSelected = isAlreadySelected
        ? currentSelection.filter((item) => item[itemKeyName] !== recordId)
        : [...currentSelection, record];

      // Update the context with the new selection
      context?.setRecords?.(newSelected);
    } else {
      const currentSelection = selectedRecords || [];

      const recordId = record[itemKeyName];
      const isAlreadySelected = currentSelection.some(
        (item) => item[itemKeyName] === recordId
      );

      const newSelected = isAlreadySelected
        ? currentSelection.filter((item) => item[itemKeyName] !== recordId)
        : [...currentSelection, record];

      const selectionData = {
        allSelected: false,
        selectedRecords: newSelected,
        unSelectedRecords: null,
        totalRecords: newSelected.length,
        filterCondition: context?.filterCondition || null
      };

      context?.setRecords?.(selectionData);
      updateRecords?.(newSelected);
    }
  };

  const listItems = [];
  allItems.map((elem, idx) => {
    const hightLightCard = selectedItem?.[itemKeyName] === elem?.[itemKeyName];

    listItems.push(
      <div
        key={idx}
        className="cursor-pointer"
        onClick={() => {
          setSelectedItemWrapper(elem);
        }}
      >
        <components.Card
          item={elem}
          selectAll={selectAll}
          handleCheckboxChange={handleCheckboxChange}
          selectedRecords={selectedRecords}
          hightLightCard={hightLightCard}
        />
      </div>
    );
  });

  return (
    <>
      <div
        className={`${
          pagination ? ' ch-95 border-bottom ' : ' ch-50 '
        } scroll  border-top p5`}
      >
        {!isRefetching && allItems.length === 0 && (
          <div className="center fh flex jcenter">
            <DisplayText element="h3" weight="SemiBold">
              <FormattedMessage
                id={noDataMessage || 'asset.details.tickets.empty'}
              />
            </DisplayText>
          </div>
        )}
        {listItems}
      </div>
      {PaginationWrapper}
    </>
  );
};

export default ListItems;
